import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ProjectsDataDto } from '../../models/dashboard.dto';

/**
 * A project's logo, or its initials on its own colour. Always beside the project's name, so it
 * is decoration: hidden from assistive technology rather than read out as two letters.
 */
@Component({
  selector: 'app-project-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    class: 'dk-avatar dk-avatar--xs',
    // The colour is the project's own, chosen by a person, so it is data rather than a token.
    '[style.--project-color]': 'project().logo ? null : project().color || null',
  },
  template: `
    @if (project().logo) {
      <img [src]="project().logo" alt="" />
    } @else {
      {{ initials() }}
    }
  `,
  styles: `
    @use '@dkds/core/tokens' as dk;

    :host {
      border-radius: dk.$radius-xs;
      background: var(--project-color, #{dk.$color-primary});
      color: dk.$color-primary-foreground;
    }

    :host(:has(img)) {
      background: transparent;
    }
  `,
})
export class ProjectAvatarComponent {
  readonly project = input.required<Pick<ProjectsDataDto, 'name' | 'logo' | 'color'>>();

  protected readonly initials = computed(() =>
    this.project()
      .name.split(/\s+/)
      .filter(Boolean)
      .map((word) => word[0])
      .slice(0, 2)
      .join(''),
  );
}
